import styles from "./style.module.css";
import { Hearts } from "react-loader-spinner";
import logo1 from "../../images/logo1.png"

export default function LoadView() {
  return (
    <>
      <div className={styles.load}>
        <img
          className={styles.load_logo}
          alt="#"
          src={logo1}
        />
        <Hearts

          color="#610935"
          height={100}
          width={100}

        />
      </div>
    </>
  );
}
